import { Route } from '@direct-frontend/modules-router';
import { AbcAnalysisAsync } from '#pages/abcAnalysis';
import { AddonEditAsync } from '#pages/addonEdit';
import { AddonsAsync } from '#pages/addons';
import { BadgeAsync } from '#pages/badge';
import { BadgesAsync } from '#pages/badges';
import { CharacteristicAsync } from '#pages/characteristic';
import { CollectionAsync, CollectionCardsActionAsync } from '#pages/collection';
import { CollectionsAsync } from '#pages/collections';
import { ContextCollectionAsync } from '#pages/contextCollection';
import { ImportProductsFromExcelAsync } from '#pages/importProductsFromExcel';
import { ProductCardAsync } from '#pages/product';
import { ProductsDashboardAsync } from '#pages/products';
import { renderWithPermission } from '#shared/lib/managerPermissions';
import {
    abcAnalysisRoute,
    addonsEditRoute,
    addonsRoute,
    badgeRoute,
    badgesRoute,
    characteristicRoute,
    collectionEditCardsActionRoute,
    collectionEditRoute,
    collectionsRoute,
    contextCollectionEditRoute,
    productCardRoute,
    productsImportExcelRoute,
    productsRoute,
    productVariantRoute,
    productVariantStocksRoute,
} from '#shared/lib/routes';

export const contentRoutes = () =>
    renderWithPermission(
        'content',
        'read',
        <>
            <Route path={productsRoute.route} element={<ProductsDashboardAsync />} />
            <Route path={productCardRoute.route} element={<ProductCardAsync />} />
            <Route path={productVariantRoute.route} element={<ProductCardAsync />}>
                {/* Дочерние URL разделов сохраняют общий ProductCard смонтированным при переключении. */}
                <Route path={productVariantStocksRoute.route} element={null} />
            </Route>
            <Route path={collectionsRoute.route} element={<CollectionsAsync />} />
            <Route path={collectionEditRoute.route} element={<CollectionAsync />}>
                <Route path={collectionEditCardsActionRoute.route} element={<CollectionCardsActionAsync />} />
            </Route>
            <Route path={abcAnalysisRoute.route} element={<AbcAnalysisAsync />} />
            <Route path={contextCollectionEditRoute.route} element={<ContextCollectionAsync />} />
            <Route path={productsImportExcelRoute.route} element={<ImportProductsFromExcelAsync />} />
            <Route path={addonsRoute.route} element={<AddonsAsync />} />
            <Route path={addonsEditRoute.route} element={<AddonEditAsync />} />
            <Route path={characteristicRoute.route} element={<CharacteristicAsync />} />
            <Route path={badgesRoute.route} element={<BadgesAsync />} />
            <Route path={badgeRoute.route} element={<BadgeAsync />} />
        </>
    );
